import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { XtField } from "nwcommon";
import { number } from "prop-types";
import { NumberUtil } from "../../../../../Xt/Utils/NumberUtil";
import { EnPrAction } from "../Common/PrReducer";
import { enum_request_type } from "../Common/NwPrConstants";
import { ShowNumberDiff } from "../Common/GridCell/AmountGridCell";

export default function NwSubTotal(props) {
 const {state,dispatch} = props;
 let subTotal = Number();
 let totalAmount =Number();
 let lastSubTotalAmount = Number();
 let lastTotalAmount = Number();

 if (state?.purchaseItem?.length > 0) {
  subTotal = state?.purchaseItem?.reduce(
    (sum, current) => NumberUtil.decimalNumSum(sum, current.total),
    0
  );

  lastSubTotalAmount = state?.purchaseItem?.reduce(
    (sum, current) => NumberUtil.decimalNumSum(sum, NumberUtil.roundToTwoDecimal((current.lastUnitPrice ? current.lastUnitPrice : 0) * (current.lastQuantity ? current.lastQuantity : 0))) ,
    0
  );

  totalAmount= subTotal
  lastTotalAmount = totalAmount;
}

  return (
    <div className="clearfix">
      <table className="table table-striped table-bordered table-line_item-total_section mb-0">
        <tbody>
          <tr>
            <td height={35}>Total Amount</td>
            <td align="right" className="amount-bold">
            

                {state?.prType !== enum_request_type.PO_CHANGE_REQUEST && (
                  <>
                    {NumberUtil.formatToTwoDecimalWithComma(state?.totalAmount)}
                 </>
                )}
                {state?.prType === enum_request_type.PO_CHANGE_REQUEST && (
                  
                    <ShowNumberDiff
                      currentValue={state?.totalAmount}
                      lastValue={lastTotalAmount}
                      formatFunction={NumberUtil.formatToTwoDecimalWithComma}
                    />
                  
                )}
                
              
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}